import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=62792cc2&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62792cc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62792cc2')) {
      api.createRecord('62792cc2', component.options)
    } else {
      api.reload('62792cc2', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=62792cc2&scoped=true&", function () {
      api.rerender('62792cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2s2vMko5176rw/JS/comp/Accordion.vue"
export default component.exports